function ChevronRightGreen() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="14"
			fill="none"
			viewBox="0 0 14 14"
		>
			<path
				fill="#1F8268"
				d="M4.874 3.684a.575.575 0 000 .884L7.624 7l-2.75 2.433a.575.575 0 000 .884.772.772 0 001 0l3.252-2.878a.575.575 0 000-.884L5.873 3.678a.78.78 0 00-.999.006z"
			/>
		</svg>
	);
}

export default ChevronRightGreen;
